<template>
  <div id="ingredients">
    <b-container class="section section-ingredients">
      <h1>INGREDIENTE</h1>
      <img src="./../assets/mustata-only.png" alt class="logo-mustata" />
      <b-row cols="1" cols-sm="1" cols-md="2" cols-lg="3">
        <b-col class="p-4 align-self-center">
          <img src="./../assets/hops.png" alt class="drawing" />
          <h4>Hamei</h4>
          <p>
            asigură gustul amar și <br> ajută la conservare
          </p>
        </b-col>
        <b-col class="p-4">
          <img src="./../assets/ingredient-3.jpg" alt class="middle" />
        </b-col>
        <b-col class="p-4 align-self-center">
          <img src="./../assets/barley.png" alt class="drawing" />
          <h4>Malț</h4>
          <p>
            prăjit și zdrobit pentru <br>a obține consistența ideală
          </p>
        </b-col>
        <b-col class="p-4">
          <img src="./../assets/ingredient-1.jpg" alt class="middle" />
        </b-col>
        <b-col class="p-4 align-self-center">
          <img src="./../assets/yeast.png" alt class="drawing" />
          <h4>Drojdie</h4>
          <p>
            leagă armonios ingredientele <br> în procesul de fermentație
          </p>
        </b-col>
        <b-col class="p-4">
          <img src="./../assets/ingredient-2.jpg" alt class="middle" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
.section-ingredients h4 {
  font-size: 20px;
  color: #8b4e2e;
  margin-top: 15px;
  font-weight: 600;
}

.section-ingredients p {
  font-size: 14px;
}

.drawing {
  width: 150px;
  height: 150px;
}

.middle {
  width: 100%;
}
</style>